var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee-component"},[_c('div',{ref:"notice",staticClass:"notice",style:(_vm.style)},[_vm._v(_vm._s(_vm.notice))])])}
var staticRenderFns = []

export { render, staticRenderFns }